import React from "react";

export default function Base({}) {
	return <>
		<path d="M21.8889 100.5C15.2223 100.5 8.88888 93.6111 7.88889 87.2778L0.444444 0.5L88.5556 6.16667C94.7777 7.05555 99.6667 12.9445 99.6667 20.0556L100.444 100.5H21.8889Z"/>
	</>
}